import {Component, EventEmitter, Input, Optional, Output, ViewChild} from '@angular/core';
import {AcFormComponent} from '../ac-form/ac-form.component';
import {AcInputContainerComponent} from '../ac-input-container/ac-input-container.component';
import {MatFormFieldControl} from '@angular/material/form-field';
import {AcInputContainerOldComponent} from '../ac-input-container-old/ac-input-container-old.component';

@Component({
    selector: 'ac-textarea',
    templateUrl: './ac-textarea.component.html',
    styleUrls: ['./ac-textarea.component.less'],
})
export class AcTextareaComponent {
    @Input() acModel: string;
    @Output() acModelChange: EventEmitter<string> = new EventEmitter<string>();

    @Input() textAreaId: string;
    @Input() maxLength: number;
    @Input() ngDisabled = false;
    @Input() placeHolderText: string;
    @Input() visibleRows: number;
    @ViewChild(MatFormFieldControl) matFormFieldControl;

    acInputContainer;

    constructor(@Optional() public acInputContainerComponent: AcInputContainerComponent,
                @Optional() public acInputContainerOldComponent: AcInputContainerOldComponent,
                @Optional() public acFormComponent: AcFormComponent) {}

    ngOnInit(){
        if(this.acInputContainerOldComponent){
            this.acInputContainer = this.acInputContainerOldComponent;
            this.visibleRows = this.visibleRows || 3;
        }else{
            this.acInputContainer = this.acInputContainerComponent;
        }

        if(this.acFormComponent && this.acFormComponent.isViewMode){
            this.ngDisabled = true;
        }
    }

    ngAfterViewInit(){
        this.acInputContainerComponent?.initializeMaterialField(this.matFormFieldControl);
    }

    textAreaChanged(text) {
        this.acModelChange.emit(text);
    }
}
